<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Agent Create",
      items: [
        {
          text: "Agent Create",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
        border_checked:false,
        disable:true,
      checked: false,
      errors: null,
        visible:false,
        message:"",
        country_list:[],
      form: {
        first_name: "",
        last_name: "",
        gender: "",
        email: "",
        country_code: "",
        country: "",
        phone_code: "",
        phone_number: "",
        city: "",
        postal_code: "",
        address: "",
          password:"",
          password_confirmation:"",
        markup_amount: "",
        markup_type: "",
        file: "",
        filename: "",
        currency: "",
        language: "",
          agency_info:false,
        agency_name: "",
        iata_no: "",
          trade_license_no:"",
        civil_aviation_certificate_no: "",
        website: "",
        fax_no: "",
        agency_country: "",
        agency_city: "",
        agency_postal_code: "",
        agency_address: "",
        management_full_name: "",
        management_ownership_title: "",
        management_phone_number: "",
        management_email: "",
        contact_person_full_name: "",
        contact_person_title: "",
        contact_person_phone_number: "",
        contact_person_email: "",
        agency_logo: "",
        civil_aviation_certificate_document: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      gender: {
        required,
      },
      email: {
        required,
      },
      country_code: {
        required,
      },
      country: {
        required,
      },
      phone_code: {
        required,
      },
      phone_number: {
        required,
      },
      city: {
        required,
      },
      address: {
        required,
      },
      postal_code: {
        required,
      },
        password: {
          required,
        },
        password_confirmation: {
          required,
        },
      markup_amount: {
        required,
      },
      markup_type: {
        required,
      },
      currency: {
        required,
      },
      language: {
        required,
      },
      agency_name: {
        required,
      },
      iata_no: {
        required,
      },
        trade_license_no:{
            required,
        },
      civil_aviation_certificate_no: {
        required,
      },
      website: {
        required,
      },
      agency_country: {
        required,
      },
      agency_city: {
        required,
      },
      agency_postal_code: {
        required,
      },
      agency_address: {
        required,
      },
      management_full_name: {
        required,
      },
      management_ownership_title: {
        required,
      },
      management_phone_number: {
        required,
      },
      management_email: {
        required,
      },
      contact_person_full_name: {
        required,
      },
      contact_person_title: {
        required,
      },
      contact_person_phone_number: {
        required,
      },
      contact_person_email: {
        required,
      },
      fax_no: {
        required,
      },
    },
  },
    computed: {
        validated() {
            if (this.form.agency_info === true) {
                return true
            }
        }
    },
    mounted() {
        this.getCountryList();
    },
            methods: {
                setCountryAndPhoneCode(event){
                  let countries=this.country_list
                    let i;
                  for(i=0;i<countries.length;i++){
                      if(countries[i].countryName==event.target.value){
                          this.form.country_code=countries[i].countryCode;
                          this.form.phone_code=countries[i].phoneCode;
                      }
                  }
                },
                setPhoneCodeAndCountry(event){
                    let countries=this.country_list
                    let i;
                    for(i=0;i<countries.length;i++){
                        if(countries[i].phoneCode==event.target.value){
                            this.form.country=countries[i].countryName;
                            this.form.phone_code=countries[i].phoneCode;
                        }
                    }
                },
                async getCountryList() {
                    try {
                        axios
                            .get("/api/country/list", {
                                params: {
                                    accessToken: localStorage.getItem("access_tocken"),
                                },
                            })
                            .then((response) => {
                                if (response.status) {
                                    this.country_list=response.data.data;
                                } else {
                                    var str = response.data.message;
                                    var jsonParse = JSON.parse(str);
                                    this.errorCheck(jsonParse);
                                }
                            })
                            .catch((error) => {
                                console.log(error.message);
                            });
                    } catch (err) {
                        console.log(err);
                    }
                },
      onClose(){
          this.visible=false;
      },
    onFileChangeAgencyLogo(e) {
      this.form.agency_logo_filename =
        "Selected File: " + e.target.files[0].name;
      this.form.agency_logo = e.target.files[0];
    },

    onFileChangeAgencyCvilCertificate(e) {
      this.form.civil_aviation_certificate_document_name =
        "Selected File: " + e.target.files[0].name;
      this.form.civil_aviation_certificate_document = e.target.files[0];
    },

    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      };
      event.preventDefault();
      var self = this;
      var formData = this.gatherFormData();
      axios
        .post("/api/agent/create", formData, config)
        .then((response) => {
          if (response.data.status) {
            this.$refs.agentForm.reset();
             this.$swal("Good job!", "Agent Created", "success");
            if(this.form.agency_info==true){
                this.$router.push({ name: "agent_list" });
            }else{
                this.$router.push({ name: "unverified_agent_list" });
            }
          } else {
            var str = response.data.message.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
      applySameDataAsAgent(event){
          if (event.target.checked==true){
              this.form.agency_country=this.form.country;
              this.form.agency_city=this.form.city;
              this.form.agency_postal_code=this.form.postal_code;
              this.form.agency_address=this.form.address;
          }
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
    gatherFormData() {
      const data = new FormData();
      data.append("accessToken", localStorage.getItem("access_tocken"));
      data.append("first_name", this.form.first_name);
      data.append("last_name", this.form.last_name);
      data.append("gender", this.form.gender);
      data.append("email", this.form.email);
      data.append("country_code", this.form.country_code);
      data.append("country", this.form.country);
      data.append("phone_code", this.form.phone_code);
      data.append("phone_number", this.form.phone_number);
      data.append("city", this.form.city);
      data.append("address", this.form.address);
      data.append("postal_code", this.form.postal_code);
      data.append("markup_amount", this.form.markup_amount);
      data.append("markup_type", this.form.markup_type);
      data.append("password",this.form.password);
      data.append("password_confirmation",this.form.password_confirmation);
      data.append("approved_by", localStorage.getItem("id"));
      data.append("approved_at", moment().format("YYYY-MM-DD HH:mm:ss"));
      data.append("currency", this.form.currency);
      data.append("language", this.form.language);
      data.append("agency_info",this.form.agency_info);
      data.append("agency_name", this.form.agency_name);
      data.append("agency_logo", this.form.agency_logo);
      data.append("iata_no", this.form.iata_no);
        data.append("trade_license_no", this.form.trade_license_no);
      data.append(
        "civil_aviation_certificate_no",
        this.form.civil_aviation_certificate_no
      );

      data.append(
        "civil_aviation_certificate_document",
        this.form.civil_aviation_certificate_document
      );
      data.append("website", this.form.website);
      data.append("fax_no", this.form.fax_no);
      data.append("agency_country", this.form.agency_country);
      data.append("agency_city", this.form.agency_city);
      data.append("agency_postal_code", this.form.agency_postal_code);
      data.append("agency_address", this.form.agency_address);
      data.append("management_full_name", this.form.management_full_name);
      data.append(
        "management_ownership_title",
        this.form.management_ownership_title
      );
      data.append("management_phone_number", this.form.management_phone_number);
      data.append("management_email", this.form.management_email);
      data.append(
        "contact_person_full_name",
        this.form.contact_person_full_name
      );
      data.append("contact_person_title", this.form.contact_person_title);
      data.append(
        "contact_person_phone_number",
        this.form.contact_person_phone_number
      );

      data.append("contact_person_email", this.form.contact_person_email);

      return data;
    },
    passwordEyeToggle() {
      var x = document.getElementById("password");
      var y = document.getElementById("eye-1");
      var z = document.getElementById("eye-2");

      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";
      }
    },
    confirmPasswordEyeToggle() {
      var x = document.getElementById("password_confirmation");
      var y = document.getElementById("eye-3");
      var z = document.getElementById("eye-4");

      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";
      }
    },
      applyAgencyInfo(event){
          if(event.target.checked==true){
              this.border_checked=true;
              this.disable=false;
              this.form.agency_info=true;
          }
          else{
              this.disable=true;
              this.border_checked=false;
              this.form.agency_info=false;
          }
      }
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <form ref="agentForm" @submit.prevent="formSubmit" class="needs-validation">
              <div class="card">
                  <div class="card-body">
                      <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-time-five"></i> Agent Information</h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="first_name">First Name</label>
                            <input
                              id="first_name"
                              v-model="form.first_name"
                              name="first_name"
                              type="text"
                              class="form-control"
                              placeholder="Type First Name"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.first_name.$error }"
                            />
                            <div
                              v-if="submitted && $v.form.first_name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.first_name.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="last_name">Last Name</label>
                            <input
                              id="last_name"
                              v-model="form.last_name"
                              name="last_name"
                              type="text"
                              class="form-control"
                              placeholder="Type Last Name"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.last_name.$error }"
                            />
                            <div
                              v-if="submitted && $v.form.last_name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.last_name.required">This value is required.</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="gender">Gender</label>
                            <select
                              id="gender"
                              name="gender"
                              v-model="form.gender"
                              type="text"
                              class="form-control"
                              placeholder="Type Gender"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.gender.$error }">
                                <option value="" disabled style="display:none" selected>Select Gender</option>a
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                            </select>
                            <div
                              v-if="submitted && $v.form.gender.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.gender.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="email">Email</label>
                            <input
                              id="email"
                              v-model="form.email"
                              name="email"
                              type="email"
                              class="form-control"
                              placeholder="Type Email"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                            />
                            <div
                              v-if="submitted && $v.form.email.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.email.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label class="required" for="country">Country</label>
                                  <select
                                      id="country"
                                      name="country"
                                      v-model="form.country"
                                      v-on:change="setCountryAndPhoneCode"
                                      type="text"
                                      class="form-control"
                                      placeholder="Select Country"
                                      value
                                      :class="{ 'is-invalid': submitted && $v.form.country.$error }">
                                      <option value="" disabled style="display:none" selected>Select Country</option>a
                                      <option v-for="(country, index) in country_list" :value="country.countryName"
                                              v-bind:key="index">{{ country.countryName}}
                                      </option>
                                  </select>
                                  <div
                                      v-if="submitted && $v.form.country.$error"
                                      class="invalid-feedback"
                                  >
                                      <span v-if="!$v.form.country.required">This value is required.</span>
                                  </div>
                              </div>
                          </div>
<!--                        <div class="col-md-6">-->
<!--                            <div class="form-group">-->
<!--                                <label class="required" for="country_code">Country Code</label>-->
<!--                                <select-->
<!--                                    id="country_code"-->
<!--                                    name="country_code"-->
<!--                                    v-model="form.country_code"-->
<!--                                    type="text"-->
<!--                                    class="form-control"-->
<!--                                    placeholder="Type Country Code"-->
<!--                                    value-->
<!--                                    :class="{ 'is-invalid': submitted && $v.form.country_code.$error }">-->
<!--                                    <option value="" disabled style="display:none" selected>Select Country Code</option>a-->
<!--                                    <option v-for="(country, index) in country_list" :value="country.countryCode"-->
<!--                                            v-bind:key="index">{{ country.countryCode }}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.country_code.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.country_code.required">This value is required.</span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="required" for="phone_code">Phone Code</label>
                                <select
                                    id="phone_code"
                                    name="phone_code"
                                    v-model="form.phone_code"
                                    v-on:change="setPhoneCodeAndCountry"
                                    type="text"
                                    class="form-control"
                                    placeholder="Select Phone Code"
                                    value
                                    :class="{ 'is-invalid': submitted && $v.form.phone_code.$error }">
                                    <option value="" disabled style="display:none" selected>Select Phone Code</option>a
                                    <option v-for="(country, index) in country_list" :value="country.phoneCode"
                                            v-bind:key="index">{{ country.phoneCode }}
                                    </option>
                                </select>
                                <div
                                    v-if="submitted && $v.form.phone_code.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.phone_code.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="phone_number">Phone Number</label>
                            <input
                              id="phone_number"
                              v-model="form.phone_number"
                              name="phone_number"
                              type="text"
                              class="form-control"
                              placeholder="Type Phone Number"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.phone_number.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.phone_number.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.phone_number.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="currency">Currency</label>
                            <input
                              id="currency"
                              v-model="form.currency"
                              name="currency"
                              type="text"
                              class="form-control"
                              placeholder="Type Currency"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.currency.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.currency.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.currency.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="language">Language</label>
                            <input
                              id="language"
                              v-model="form.language"
                              name="language"
                              type="text"
                              class="form-control"
                              placeholder="Type Language"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.language.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.language.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.language.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="city">City</label>
                            <input
                              id="city"
                              v-model="form.city"
                              name="city"
                              type="text"
                              class="form-control"
                              placeholder="Type City"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.city.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.city.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.city.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="postal_code">Postal Code</label>
                            <input
                              id="postal_code"
                              v-model="form.postal_code"
                              name="postal_code"
                              type="text"
                              class="form-control"
                              placeholder="Type Postal Code"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.postal_code.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.postal_code.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.postal_code.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="address">Address</label>
                            <textarea
                              id="address"
                              v-model="form.address"
                              name="address"
                              type="text"
                              class="form-control"
                              placeholder="Type Address"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.address.$error }"
                            >
                            </textarea>
                            <div
                              v-if="submitted && $v.form.address.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.address.required">This value is required.</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="markup_amount">Markup Amount</label>
                            <input
                              id="markup_amount"
                              v-model="form.markup_amount"
                              name="markup_amount"
                              type="text"
                              class="form-control"
                              placeholder="Type Markup Amount"
                              autocomplete="off"
                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.markup_amount.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.markup_amount.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="markup_type">Markup Type</label>
                            <select
                              id="markup_type"
                              name="markup_type"
                              v-model="form.markup_type"
                              type="text"
                              class="form-control"
                              placeholder="Type markup type"
                            >
                                <option value="" disabled style="display:none" selected>Select Markup Type</option>a
                              <option value="flat">flat</option>
                              <option value="percentage">Percentage</option>
                            </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.markup_type.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.markup_type.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label class="required" for="password">Passowrd</label>
                                  <input
                                      id="password"
                                      v-model="form.password"
                                      name="password"
                                      type="password"
                                      class="form-control"
                                      placeholder="Type Passowrd"
                                      autocomplete="off"
                                      value
                                      :class="{ 'is-invalid': submitted && $v.form.password.$error }"
                                  />
                                  <span class="eye" >
                                    <i class="fa fa-eye" aria-hidden="true" @click="passwordEyeToggle()" id="eye-1"> </i>
                                    <i class="fa fa-eye-slash" aria-hidden="true" @click="passwordEyeToggle()" id="eye-2"> </i>
                                  </span>
                                  <div
                                      v-if="submitted && $v.form.password.$error"
                                      class="invalid-feedback"
                                  >
                                      <span v-if="!$v.form.password.required">This value is required.</span>
                                  </div>
                              </div>
                          </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label class="required" for="password_confirmation">Confirm Password</label>
                                  <input
                                      id="password_confirmation"
                                      v-model="form.password_confirmation"
                                      name="password_confirmation"
                                      type="password"
                                      class="form-control"
                                      placeholder="Confirm Password"
                                      autocomplete="off"
                                      value
                                      :class="{ 'is-invalid': submitted && $v.form.password_confirmation.$error }"
                                  />
                                  <span class="eye" >
                                    <i class="fa fa-eye" aria-hidden="true" @click="confirmPasswordEyeToggle()" id="eye-3"> </i>
                                    <i class="fa fa-eye-slash" aria-hidden="true" @click="confirmPasswordEyeToggle()" id="eye-4"> </i>
                                  </span>
                                  <div
                                      v-if="submitted && $v.form.password_confirmation.$error"
                                      class="invalid-feedback"
                                  >
                                      <span v-if="!$v.form.password_confirmation.required">This value is required.</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
                <h2 class="badge badge-danger">Fill Agency Information</h2> <input type="checkbox" v-model="border_checked" @change="applyAgencyInfo($event)" />
              <div class="card border border-danger">
                    <div class="card-body">
                        <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-time-five"></i> Agency Information</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="required" for="agency_name">Agency Name</label>
                                    <input
                                    id="agency_name"
                                    v-model="form.agency_name"
                                    :disabled="this.disable"
                                    name="agency_name"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Agency Name"
                                    value
                                    :class="{ 'is-invalid': submitted && $v.form.agency_name.$error && validated}"
                                    />
                                    <div
                                    v-if="submitted && $v.form.agency_name.$error"
                                    class="invalid-feedback"
                                    >
                                    <span  v-if="!$v.form.agency_name.required && validated">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Agency Logo</label>
                                    <div class="custom-file">
                                        <input id="agency_logo" :disabled="this.disable" type="file" ref="agency_logo" name="agency_logo" v-on:change="onFileChangeAgencyLogo($event)" class="custom-file-input" />
                                        <label class="custom-file-label" for="agency_logo">Logo</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="iata_no">IATA No</label>
                                    <input
                                    id="iata_no"
                                    v-model="form.iata_no"
                                    name="iata_no"
                                    :disabled="this.disable"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type IATA No"
                                    value
                                    :class="{ 'is-invalid-no': submitted && $v.form.iata_no.$error }"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.iata_no.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.iata_no.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="trade_license_no">Trade License No</label>
                                    <input
                                        id="trade_license_no"
                                        v-model="form.trade_license_no"
                                        :disabled="this.disable"
                                        name="trade_license_no"
                                        type="text"
                                        class="form-control"
                                        placeholder="Type Trade License No"
                                        value
                                        :class="{ 'is-invalid-no': submitted && $v.form.trade_license_no.$error }"
                                    />
                                    <!--                                    <div-->
                                    <!--                                    v-if="submitted && $v.form.iata_no.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                    >-->
                                    <!--                                    <span v-if="!$v.form.iata_no.required">This value is required.</span>-->
                                    <!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="civil_aviation_certificate_no">Civil Aviation Certificate No</label>
                                    <input
                                    id="civil_aviation_certificate_no"
                                    v-model="form.civil_aviation_certificate_no"
                                    name="civil_aviation_certificate_no"
                                    :disabled="this.disable"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Civil Aviation Certificate No"
                                    value
                                    :class="{ 'is-invalid-no': submitted && $v.form.civil_aviation_certificate_no.$error }"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.civil_aviation_certificate_no.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.civil_aviation_certificate_no.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Civil Aviation Certificate Document</label>
                                    <div class="custom-file">
                                        <input id="civil_aviation_certificate_document" type="file" :disabled="this.disable" ref="civil_aviation_certificate_document" name="civil_aviation_certificate_document" v-on:change="onFileChangeAgencyCvilCertificate($event)" class="custom-file-input" />
                                        <label class="custom-file-label" for="civil_aviation_certificate_document">Civil Aviation Certificate Document</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="website">Website</label>
                                    <input
                                    id="website"
                                    v-model="form.website"
                                    :disabled="this.disable"
                                    name="website"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Website Address"
                                    >
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.website.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.website.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="fax_no">FAX No</label>
                                    <input
                                    id="fax_no"
                                    v-model="form.fax_no"
                                    :disabled="this.disable"
                                    name="fax_no"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Fax Number"
                                    >
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.fax_no.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.fax_no.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            </div>
                        <input type="checkbox" v-model="checked" :disabled="this.disable" @change="applySameDataAsAgent($event)" /> <h2 class="badge badge-info">Same as Agent</h2>
                        <div class="row">


                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="required" for="agency_country">Country</label>
                                    <input
                                    id="agency_country"
                                    v-model="form.agency_country"
                                    name="agency_country"
                                    :disabled="this.disable"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Country Name"
                                    value
                                    :class="{ 'is-invalid': submitted && $v.form.agency_country.$error && validated}"
                                    >
                                    <div
                                    v-if="submitted && $v.form.agency_country.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.agency_country.required && validated">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="required" for="agency_city">City</label>
                                    <input
                                    id="agency_city"
                                    v-model="form.agency_city"
                                    :disabled="this.disable"
                                    name="agency_city"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type City"
                                    value
                                    :class="{ 'is-invalid': submitted && $v.form.agency_city.$error && validated}"
                                    >
                                    <div
                                    v-if="submitted && $v.form.agency_city.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.agency_city.required && validated">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="required" for="agency_postal_code">Postal Code</label>
                                    <input
                                    id="agency_postal_code"
                                    v-model="form.agency_postal_code"
                                    :disabled="this.disable"
                                    name="agency_postal_code"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Postal Code"
                                    value
                                    :class="{ 'is-invalid': submitted && $v.form.agency_postal_code.$error && validated}"
                                    >
                                    <div
                                    v-if="submitted && $v.form.agency_postal_code.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.agency_postal_code.required && validated">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="required" for="agency_address">Address</label>
                                    <textarea
                                    id="agency_address"
                                    v-model="form.agency_address"
                                    :disabled="this.disable"
                                    name="agency_address"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Address"
                                    value
                                    :class="{ 'is-invalid': submitted && $v.form.agency_address.$error && validated}"
                                    >
                                    </textarea>
                                    <div
                                    v-if="submitted && $v.form.agency_address.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.agency_address.required && validated">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-time-five"></i> Management Information</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="management_full_name">Management Full Name</label>
                                    <input
                                    id="management_full_name"
                                    v-model="form.management_full_name"
                                    :disabled="this.disable"
                                    name="management_full_name"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Management Full Name"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.management_full_name.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.management_full_name.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="management_ownership_title">Management Ownership Title</label>
                                    <input
                                    id="management_ownership_title"
                                    v-model="form.management_ownership_title"
                                    :disabled="this.disable"
                                    name="management_ownership_title"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Management Ownership Title"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.management_ownership_title.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.management_ownership_title.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="management_phone_number">Management Phone Number</label>
                                    <input
                                    id="management_phone_number"
                                    v-model="form.management_phone_number"
                                    :disabled="this.disable"
                                    name="management_phone_number"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Management Phone Number"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.management_phone_number.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.management_phone_number.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="management_email">Management Email</label>
                                    <input
                                    id="management_email"
                                    v-model="form.management_email"
                                    :disabled="this.disable"
                                    name="management_email"
                                    type="email"
                                    class="form-control"
                                    placeholder="Type Management Email Address"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.management_email.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.management_email.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-time-five"></i> Contact Information</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="contact_person_title">Contact Person Title</label>
                                    <input
                                    id="contact_person_title"
                                    v-model="form.contact_person_title"
                                    :disabled="this.disable"
                                    name="contact_person_title"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Contact Person Title"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.contact_person_title.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.contact_person_title.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="contact_person_full_name">Contact Person Full Name</label>
                                    <input
                                    id="contact_person_full_name"
                                    v-model="form.contact_person_full_name"
                                    :disabled="this.disable"
                                    name="contact_person_full_name"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Contact Person Full Name"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.contact_person_full_name.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.contact_person_full_name.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="contact_person_phone_number">Contact Person Phone Number</label>
                                    <input
                                    id="contact_person_phone_number"
                                    v-model="form.contact_person_phone_number"
                                    :disabled="this.disable"
                                    name="contact_person_phone_number"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type Contact Person Phone Number"

                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.contact_person_phone_number.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.contact_person_phone_number.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="contact_person_email">Contact Person Email</label>
                                    <input
                                    id="contact_person_email"
                                    v-model="form.contact_person_email"
                                    :disabled="this.disable"
                                    name="contact_person_email"
                                    type="email"
                                    class="form-control"
                                    placeholder="Type Contact Person Email"
                                    />
<!--                                    <div-->
<!--                                    v-if="submitted && $v.form.contact_person_email.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                    >-->
<!--                                    <span v-if="!$v.form.contact_person_email.required">This value is required.</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>


<style>
  .eye{
    display: flex;
    position: absolute;
    right: 20px;
    top: 40px;
  }
  .eye:hover{
    box-shadow: 30px;
    cursor: pointer;
  }
  #eye-1, #eye-3{
    display: none;
  }

</style>
